import { css } from '@emotion/core';

export const textSmallPrimary = css`
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-12) / var(--unnamed-line-spacing-15)
    var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-2c2c2c);
  text-align: left;
  font: normal normal bold 1.2em/1.5em Inter;
  letter-spacing: 0em;
  color: #2c2c2c;
  opacity: 1;
`;

export const textSmallSecondary = css`
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-medium) var(--unnamed-font-size-10) / 1.2em
    var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-858585);
  text-align: left;
  font: normal normal medium 1em/1.2em Inter;
  letter-spacing: 0em;
  color: #858585;
  opacity: 1;
`;

export const textMediumPrimary = css`
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-14) / var(--unnamed-line-spacing-21)
    var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-555555);
  text-align: left;
  font: normal normal bold 1.4em/2.1em Inter;
  letter-spacing: 0em;
  color: #555555;
`;

export const textMediumSecondary = css`
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-medium) var(--unnamed-font-size-12) /
    var(--unnamed-line-spacing-15) var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-858585);
  text-align: left;
  font: normal normal medium 1.2em/1.5em Inter;
  letter-spacing: 0em;
  color: #858585;
`;

export const textMediumTertiary = css`
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-10) / var(--unnamed-line-spacing-54)
    var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-858585);
  text-align: right;
  font: normal normal bold 1em/5.4em Inter;
  letter-spacing: 0em;
  color: #858585;
  text-transform: uppercase;
`;

export const textLargePrimary = css`
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-16) / var(--unnamed-line-spacing-54)
    var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-262758);
  text-align: right;
  font: normal normal bold 1.6em/5.4em Inter;
  letter-spacing: 0em;
  color: #262758;
`;

export const buttonTextPrimary = css`
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-14) / var(--unnamed-line-spacing-21)
    var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-ffffff);
  text-align: center;
  font: normal normal bold 1.4em/2.1em Inter;
  letter-spacing: 0em;
  color: #ffffff;
  text-transform: uppercase;
`;

export const buttonTextSecondary = css`
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-14) / var(--unnamed-line-spacing-21)
    var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-262758);
  text-align: center;
  font: normal normal bold 1.4em/2.1em Inter;
  letter-spacing: 0em;
  color: #262758;
  text-transform: uppercase;
`;

export const textArrow = css`
  width: 3.7em;
  height: 1.5em;
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-12) / var(--unnamed-line-spacing-15)
    var(--unnamed-font-family-inter);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-2c2c2c);
  text-align: right;
  font: normal normal bold 1.2em/1.5em Inter;
  letter-spacing: 0em;
  color: #2c2c2c;
  opacity: 1;
`;
